import Image from '@base/Image';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getQuizDetails } from '@selectors/quizTaking';
import { useRouter } from 'next/router';

import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { modeDetails } from '@cont/Quiz/utils';
import Card from './Card';
import useLanguages from '../../Common/useLanguages';

const LocationIcon = 'quiz/venue-location.svg';
const LanguageIcon = 'quiz/language.svg';

export const Wrapper = styled.div`
  display: grid;
  grid-gap: ${Spacings.SPACING_12B};
  grid-template-columns: 250px 250px;
  align-items: center;
`;

const icon = <Image width={20} height={20} src={LocationIcon} alt="timing" />;

const OfflineStats = () => {
  const { query } = useRouter();
  const { quizUID } = query;
  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const { offline_quiz_details: offlineQuizDetails } = quizDetails;
  const { venue, mode } = offlineQuizDetails;

  const { formatedLanguages } = useLanguages();
  const quizDuration = `${Math.round(quizDetails.duration / 60)} mins`;

  const getModeDetails = () => {
    return modeDetails[mode];
  };
  return (
    <Wrapper>
      {venue ? (
        <Card
          key="venue-card"
          icon={icon}
          info={{
            text: `${venue}`,
            subText: `${getModeDetails()} · ${quizDuration}`
          }}
        />
      ) : null}
      {formatedLanguages.length ? (
        <Card
          key="quiz-language-card"
          icon={
            <Image width={20} height={20} src={LanguageIcon} alt="languages" />
          }
          info={{ text: 'Languages', subText: formatedLanguages }}
        />
      ) : null}
    </Wrapper>
  );
};

export default OfflineStats;
